import React from 'react';
import Script from 'react-load-script';

const CmsScript = ({ gridItems }) => (
  <Script
  url="https://identity.netlify.com/v1/netlify-identity-widget.js"
  onLoad={() => {
    if (window.netlifyIdentity) {
      window.netlifyIdentity.on('init', user => {
        if (!user) {
          window.netlifyIdentity.on('login', () => {
            document.location.href = '/admin/';
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }}
  />
);

export default CmsScript;



// WEBPACK FOOTER //
// ./src/components/CmsScript.js